import { useForm } from 'react-hook-form';
import { FundRequestStatus } from '~/enums/fundRequest';

const AppealedStatusModal = ({
    modalOpen,
    setModalOpen,
    handleStatusUpdate,
}: {
    modalOpen: boolean;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    handleStatusUpdate: (
        status: FundRequestStatus,
        note: string
    ) => Promise<void>;
}) => {
    const { register, handleSubmit, formState, reset } = useForm({
        defaultValues: {
            note: '',
        },
    });

    const { isSubmitting } = formState;

    const onSubmit = async (data: any) => {
        await handleStatusUpdate(FundRequestStatus.APPEALED, data.note);
        reset({ note: '' });
        setModalOpen(false);
    };

    return (
        <>
            {modalOpen && (
                <div
                    className='fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-75'
                    onClick={() => setModalOpen(false)}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        className='relative w-full max-w-xl rounded-lg bg-white shadow-lg'
                    >
                        <div className='p-7'>
                            <h2 className='mb-4 text-3xl font-semibold'>
                                Submit for Approval
                            </h2>
                            <p>
                                Please provide a <strong>brief</strong>{' '}
                                explanation to the Grant Committee as to why we
                                should make an exception for this request.
                            </p>

                            <div className='mt-6'>
                                <label className='block font-bold'>
                                    Note <span className='text-red'>*</span>
                                </label>
                                <textarea
                                    className='w-full resize-none rounded border p-2'
                                    placeholder='Text'
                                    rows={6}
                                    {...register('note')}
                                />
                            </div>
                            <div className='flex gap-[16px]'>
                                <button
                                    onClick={() => setModalOpen(false)}
                                    type='button'
                                    className='mt-[30px]  rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-[#E6F7F8] hover:bg-[#E6F7F8]'
                                >
                                    Cancel
                                </button>
                                <button
                                    type='button'
                                    className={`mt-[30px] rounded-full border-[2px] border-[#FEBF3E] bg-[#FEBF3E] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase  transition-colors duration-500 ${
                                        isSubmitting
                                            ? 'cursor-not-allowed opacity-50'
                                            : 'hover:border-[#E6F7F8] hover:bg-[#E6F7F8]'
                                    }`}
                                    onClick={handleSubmit(onSubmit)}
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting
                                        ? 'Saving...'
                                        : 'Submit for Approval'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AppealedStatusModal;
